"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function filterObject(obj, key) {
    for (var i in obj) {
        if (!obj.hasOwnProperty(i))
            continue;
        if ((typeof obj[i] === 'object' && obj[i] !== null) ||
            Array.isArray(obj[i])) {
            filterObject(obj[i], key);
        }
        else if (i === key) {
            delete obj[key];
        }
    }
    return obj;
}
exports.default = filterObject;
